export default {
  getPermissions: {
    server: '/permissions',
    method: 'get',
  },
};
